<div class="modal-header">
    <p class="modal-title">Herramientas Y Controles para {{actividad.actividad}} de {{trabajador.nombre}}</p>
    <button type="button"  class="close btn-sm" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">

  <div *ngIf="actividad.actividad == 'TRABAJO EN ALTURAS' ">
    <div class="card">

    
        <p>Selección de herramientas y equipos de trabajo</p>
        <div class="container">
          <div class="row">
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de Arneses: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.arneses}}</small></p>
              </div>
            </div>
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de Andamios: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.andamios}}</small></p>
               
              </div>
            </div>
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de Eslingas: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.eslingas}}</small></p>
                
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div>
                <div position="stacked"><small>Eslingas de posicionamiento: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.eslingaDePosicionamiento}}</small></p>
              </div>
            </div>
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de cascos: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.cascos}}</small></p>
              </div>
            </div>
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de Tie Off: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.tieOff}}</small></p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de poleas: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.poleas}}</small></p>
              </div>
            </div>
            
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de descendedores: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.descendedor}}</small></p>
              </div>
            </div>

            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de gibbs: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.gibbs}}</small></p>
              </div>
            </div>
          </div>
          <div class="row">
            
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de Líneas de vida: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.lineaDeVida}}</small></p>
              </div>
            </div>
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de arrestadores: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.arrestador}}</small></p>
              </div>
            </div>
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de mosquetones: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.mosquetones}}</small></p>
              </div>
            </div>
          </div>
          <div class="row">
            
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de cuerdas: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.cuerdas}}</small></p>
              </div>
            </div>
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de escaleras: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.escaleras}}</small></p>
              </div>
            </div>
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de cintas de anclaje: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.cintaDeAnclaje}}</small></p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div>
                <div position="stacked"><small>No. pertigas: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.pertiga}}</small></p>
              </div>
            </div>
            <div class="col-6">
              <div>
                <div position="stacked"><small>Otros: </small></div>
                <p><small>{{herramientasYControlesTrabajoEnAlturas.herramientas.otros}}</small></p>
              </div>
            </div>
          </div>
        </div>
      
    </div>
    
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Actividades declaradas:</small>
          </div>
          <p><small>{{herramientasYControlesTrabajoEnAlturas.actividadIncluye}}</small></p>
          
        </div>
      
    </div>
    
    <div class="card">
      
    
        <div>
          <div position="stacked">
            <small>Peligros declarados:</small>
          </div>
          <p><small>herramientasYControlesTrabajoEnAlturas.peligros</small></p>
          
        </div>
      
    </div>
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Controles declarados:</small>
          </div>
          <p><small>{{herramientasYControlesTrabajoEnAlturas.controles}}</small></p>
        </div>
      
    </div>
  </div>


<div *ngIf="actividad.actividad == 'TRABAJO EN CALIENTE' ">
  <div class="card">
  
      <div class="container">
        <div class="row">
          <div class="col-4">
            <div>
              <div position="stacked"><small>No. de Pulidoras: </small></div>
              <p><small>{{herramientasYControlesTrabajoEnCaliente.herramientas.pulidoras}}</small></p>
            </div>
          </div>
          <div class="col-4">
            <div>
              <div position="stacked"><small>No. de Motosoldadores: </small></div>
              <p><small>{{herramientasYControlesTrabajoEnCaliente.herramientas.motosoldadores}}</small></p>
            </div>
          </div>
          <div class="col-4">
            <div>
              <div position="stacked"><small>No. de Esmeriles: </small></div>
              <p><small>{{herramientasYControlesTrabajoEnCaliente.herramientas.esmeriles}}</small></p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div>
              <div position="stacked"><small>Plantas eléctricas: </small></div>
              <p><small>{{herramientasYControlesTrabajoEnCaliente.herramientas.plantasElectricas}}</small></p>
            </div>
          </div>
          <div class="col-4">
            <div>
              <div position="stacked"><small>Taladros percutores: </small></div>
              <p><small>{{herramientasYControlesTrabajoEnCaliente.herramientas.taladrosPercutores}}</small></p>
            </div>
          </div>
          <div class="col-4">
            <div>
              <div position="stacked"><small>No. de sierras: </small></div>
              <p><small>{{herramientasYControlesTrabajoEnCaliente.herramientas.sierras}}</small></p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div>
              <div position="stacked"><small>No. de motosierras: </small></div>
              <p><small>{{herramientasYControlesTrabajoEnCaliente.herramientas.motosierras}}</small></p>
            </div>
          </div>
          
          <div class="col-4">
            <div>
              <div position="stacked"><small>No. de guadañas: </small></div>
              <p><small>{{herramientasYControlesTrabajoEnCaliente.herramientas.guadanas}}</small></p>
            </div>
          </div>

          <div class="col-4">
            <div>
              <div position="stacked"><small>Otros que generen chispas: </small></div>
              <p><small>{{herramientasYControlesTrabajoEnCaliente.herramientas.otrosChispas}}</small></p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div>
              <div position="stacked"><small>Otros: </small></div>
              <p><small>{{herramientasYControlesTrabajoEnCaliente.herramientas.otros}}</small></p>
            </div>
          </div>
        </div>
        
        
      
      </div>
    
  </div>
  
  <div class="card">
  
      <div>
        <div position="stacked">
          <small>Actividades declaradas:</small>
        </div>
        <p><small>{{herramientasYControlesTrabajoEnCaliente.actividadIncluye}}</small></p>
      </div>
    
  </div>
  
  <div class="card">
  
      <div>
        <div position="stacked">
          <small>Peligros declarados:</small>
        </div>
        <p><small>{{herramientasYControlesTrabajoEnCaliente.peligros}}</small></p>
      </div>
    
  </div>
  <div class="card">
  
      <div>
        <div position="stacked">
          <small>Controles declarados:</small>
        </div>
        <p><small>{{herramientasYControlesTrabajoEnCaliente.controles}}</small></p>
      </div>
    
  </div>
</div>



  <div *ngIf="actividad.actividad == 'LEVANTAMIENTO MECÁNICO' ">
    <div class="card">
    
        <div class="container">
          <div class="row">
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de grúas: </small></div>
                <p><small>{{herramientasYControlesLevantamientoMecanico.herramientas.grua}}</small></p>
              </div>
            </div>
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de Camión Brazo Grúa: </small></div>
                <p><small>{{herramientasYControlesLevantamientoMecanico.herramientas.camionBrazoGrua}}</small></p>
              </div>
            </div>
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de Montacargas: </small></div>
                <p><small>{{herramientasYControlesLevantamientoMecanico.herramientas.montacargas}}</small></p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de Telehandlers: </small></div>
                <p><small>{{herramientasYControlesLevantamientoMecanico.herramientas.telehandlers}}</small></p>
              </div>
            </div>
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de aparejos: </small></div>
                <p><small>{{herramientasYControlesLevantamientoMecanico.herramientas.aparejos}}</small></p>
              </div>
            </div>
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de gibbs: </small></div>
                <p><small>{{herramientasYControlesLevantamientoMecanico.herramientas.gibbs}}</small></p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de arrestadores: </small></div>
                <p><small>{{herramientasYControlesLevantamientoMecanico.herramientas.arrestadores}}</small></p>
              </div>
            </div>
            
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de mosquetones: </small></div>
                <p><small>{{herramientasYControlesLevantamientoMecanico.herramientas.mosquetones}}</small></p>
              </div>
            </div>
  
            <div class="col-4">
              <div>
                <div position="stacked"><small>No. de cuerdas: </small></div>
                <p><small>{{herramientasYControlesLevantamientoMecanico.herramientas.cuerdas}}</small></p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div>
                <div position="stacked"><small>Otros: </small></div>
                <p><small>{{herramientasYControlesLevantamientoMecanico.herramientas.otros}}</small></p>
              </div>
            </div>
          </div>
          
  
        
        </div>
      
    </div>
    
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Actividades declaradas:</small>
          </div>
          <p><small>{{herramientasYControlesLevantamientoMecanico.actividadIncluye}}</small></p>
        </div>
      
    </div>
    
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>peligros declarados:</small>
          </div>
          <p><small>{{herramientasYControlesLevantamientoMecanico.peligros}}</small></p>
        </div>
      
    </div>
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Controles declarados:</small>
          </div>
          <p><small>{{herramientasYControlesLevantamientoMecanico.controles}}</small></p>
        </div>
      
    </div>
  </div>




  <div *ngIf="actividad.actividad == 'ENERGÍAS PELIGROSAS' ">
    <div class="card">
    
        <div class="container">
          <div class="row">
            <div class="col">
              <div>
                <div position="stacked"><small>Otros: </small></div>
                <p><small>{{herramientasYControlesEnergiasPeligrosas.herramientas.otros}}</small></p>
              </div>
            </div>
          </div>
        </div>
    </div>
    
    <div class="card">
        <div>
          <div position="stacked">
            <small>Actividades declaradas:</small>
          </div>
          <p><small>{{herramientasYControlesEnergiasPeligrosas.actividadIncluye}}</small></p>
        </div>
    </div>
    
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Peligros declarados:</small>
          </div>
          <p><small>{{herramientasYControlesEnergiasPeligrosas.peligros}}</small></p>
        </div>
      
    </div>
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Controles declarados</small>
          </div>
          <p><small>{{herramientasYControlesEnergiasPeligrosas.controles}}</small></p>
        </div>
      
    </div>
  </div>



  <div *ngIf="actividad.actividad == 'ESPACIOS CONFINADOS' ">
    <div class="card">
    
        <div class="container">
          <div class="row">
            <div class="col">
              <div>
                <div position="stacked"><small>Otros: </small></div>
                <p><small>{{herramientasYControlesEspaciosConfinados.herramientas.otros}}</small></p>
              </div>
            </div>
          </div>
        </div>
      
    </div>
    
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Actividades declaradas:</small>
          </div>
          <p><small>{{herramientasYControlesEspaciosConfinados.actividadIncluye}}</small></p>
        </div>
      
    </div>
    
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Peligros declarados:</small>
          </div>
          <p><small>{{herramientasYControlesEspaciosConfinados.peligros}}</small></p>
        </div>
      
    </div>
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Controles declarados</small>
          </div>
          <p><small>{{herramientasYControlesEspaciosConfinados.controles}}</small></p>
        </div>
      
    </div>
  </div>



  <div *ngIf="actividad.actividad == 'HAZMAT' ">
    <div class="card">
    
        <div class="container">
          <div class="row">
            <div class="col">
              <div>
                <div position="stacked"><small>Otros: </small></div>
                <p><small>{{herramientasYControlesHazmat.herramientas.otros}}</small></p>
              </div>
            </div>
          </div>
        </div>
      
    </div>
    
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Actividades declaradas:</small>
          </div>
          <p><small>herramientasYControlesHazmat.actividadIncluye</small></p>
        </div>
      
    </div>
    
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Peligros declarados:</small>
          </div>
          <p><small>{{herramientasYControlesHazmat.peligros}}</small></p>
        </div>
      
    </div>
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Controles declarados:</small>
          </div>
          <p><small>{{herramientasYControlesHazmat.controles}}</small></p>
        </div>
      
    </div>
  </div>



  <div *ngIf="actividad.actividad == 'SUPERVISIÓN Y MONITOREO' ">
    <div class="card">
    
        <div class="container">
          <div class="row">
            <div class="col">
              <div>
                <div position="stacked"><small>Otros: </small></div>
                <p><small>{{herramientasYControlesSupervicionYmonitoreo.herramientas.otros}}</small></p>
              </div>
            </div>
          </div>
        </div>
      
    </div>
    
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Actividades declaradas:</small>
          </div>
          <p><small>{{herramientasYControlesSupervicionYmonitoreo.actividadIncluye}}</small></p>
        </div>
      
    </div>
    
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Peligros declarados:</small>
          </div>
          <p><small>{{herramientasYControlesSupervicionYmonitoreo.peligros}}</small></p>
        </div>
      
    </div>
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Controles declarados:</small>
          </div>
          <p><small>{{herramientasYControlesSupervicionYmonitoreo.controles}}</small></p>
        </div>
      
    </div>
  </div>



  <div *ngIf="actividad.actividad == 'OTROS' ">
    <div class="card">

    
        <div class="container">
          <div class="row">
            <div class="col">
              <div>
                <div position="stacked"><small>Otros: </small></div>
                <p><small>{{herramientasYControlesOtros.herramientas.otros}}</small></p>
              </div>
            </div>
          </div>
        </div>
      
    </div>
    
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Actividades declaradas: </small>
            <p><small>{{herramientasYControlesOtros.actividadIncluye}}</small></p>
          </div>
        </div>
      
    </div>
    
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Peligros declarados</small>
          </div>
          <p><small>{{herramientasYControlesOtros.peligros}}</small></p>
        </div>
      
    </div>
    <div class="card">
    
        <div>
          <div position="stacked">
            <small>Controles declarados:</small>
          </div>
          <p><small>{{herramientasYControlesOtros.controles}}</small></p>
        </div>
      
    </div>
  </div>

</div>

  
  
  
    

  
  
  
  


